import InteractiveCatalogPageItem from '../../model/interactive/InteractiveCatalogPageItem';
import ImageItem from '../../model/interactive/items/ImageItem';
import ButtonItem from '../../model/interactive/items/ButtonItem';
import ImageButtonItem from '../../model/interactive/items/ImageButtonItem';
import AudioItem from '../../model/interactive/items/AudioItem';
import VideoItem from '../../model/interactive/items/VideoItem';
import ScrollImageItem from '../../model/interactive/items/ScrollImageItem';
import GalleryItem from '../../model/interactive/items/GalleryItem';
import AnimatedImageItem from '../../model/interactive/items/AnimatedImageItem';
import WebZipItem from '../../model/interactive/items/WebZipItem';
import BrowserItem from '../../model/interactive/items/BrowserItem';
import MultiStateObjectItem from '../../model/interactive/items/MultiStateObjectItem';
import MultiStateObject from '../../model/interactive/items/MultiStateObject';
import PanoramaImageItem from '../../model/interactive/items/PanoramaImageItem';
import TouchAlphaImageItem from '../../model/interactive/items/TouchAlphaImageItem';
import TouchImageSequenceItem from '../../model/interactive/items/TouchImageSequenceItem';

import ItemActionParser from './ItemActionParser';

export default class InteractiveCatalogPageItemParser {

    static parse(node) {
        let interactiveCatalogPageItem = new InteractiveCatalogPageItem();

        let type = node.attr('xsi:type');
        switch (type) {
            case 'ns2:ImageItem':
                interactiveCatalogPageItem = new ImageItem();
                interactiveCatalogPageItem.path = node.children('ns2\\:path').text();
                break;
            case 'ns2:ButtonItem':
                interactiveCatalogPageItem = new ButtonItem();
                node.children('ns2\\:action').each((i, elem) => {
                    interactiveCatalogPageItem.actions.push(ItemActionParser.parse($(elem)));
                });
                break;
            case 'ns2:ImageButtonItem':
                interactiveCatalogPageItem = new ImageButtonItem();
                interactiveCatalogPageItem.normalPath = node.children('ns2\\:normalPath').text();
                node.children('ns2\\:action').each((i, elem) => {
                    interactiveCatalogPageItem.actions.push(ItemActionParser.parse($(elem)));
                });
                break;
            case 'ns2:AudioItem':
                interactiveCatalogPageItem = new AudioItem();
                interactiveCatalogPageItem.path = node.children('ns2\\:path').text();
                interactiveCatalogPageItem.loop = (node.children('ns2\\:loop').text() == 'true');
                interactiveCatalogPageItem.autoPlay = (node.children('ns2\\:autoPlay').text() == 'true');
                interactiveCatalogPageItem.stopOnPageTurn = (node.children('ns2\\:stopOnPageTurn').text() == 'true');
                break;
            case 'ns2:VideoItem':
                interactiveCatalogPageItem = new VideoItem();
                interactiveCatalogPageItem.path = node.children('ns2\\:path').text();
                interactiveCatalogPageItem.loop = (node.children('ns2\\:loop').text() == 'true');
                interactiveCatalogPageItem.autoPlay = (node.children('ns2\\:autoPlay').text() == 'true');
                interactiveCatalogPageItem.autoPlayAlways = (node.children('ns2\\:autoPlayAlways').text() == 'true');
                interactiveCatalogPageItem.fullScreen = (node.children('ns2\\:fullScreen').text() == 'true');
                interactiveCatalogPageItem.controlsStyle = node.children('ns2\\:controlsStyle').text();
                break;
            case 'ns2:ScrollImageItem':
                interactiveCatalogPageItem = new ScrollImageItem();
                interactiveCatalogPageItem.path = node.children('ns2\\:path').text();
                interactiveCatalogPageItem.contentWidth = InteractiveCatalogPageItemParser.parseLayoutNumericValue(node.children('ns2\\:contentWidth'));
                interactiveCatalogPageItem.contentHeight = InteractiveCatalogPageItemParser.parseLayoutNumericValue(node.children('ns2\\:contentHeight'));
                interactiveCatalogPageItem.showBars = (node.children('ns2\\:showBars').text() == 'true');
                break;
            case 'ns2:GalleryItem':
                interactiveCatalogPageItem = new GalleryItem();
                node.children('ns2\\:path').each((i, elem) => {
                    interactiveCatalogPageItem.paths.push($(elem).text());
                });
                break;
            case 'ns2:AnimatedImageItem':
                interactiveCatalogPageItem = new AnimatedImageItem();
                node.children('ns2\\:path').each((i, elem) => {
                    interactiveCatalogPageItem.paths.push($(elem).text());
                });
                interactiveCatalogPageItem.step = parseFloat(node.children('ns2\\:step').text());
                interactiveCatalogPageItem.loop = (node.children('ns2\\:loop').text() == 'true');
                break;
            case 'ns2:WebZipItem':
                interactiveCatalogPageItem = new WebZipItem();
                interactiveCatalogPageItem.zipPath = node.children('ns2\\:zipPath').text();
                interactiveCatalogPageItem.preLoad = (node.children('ns2\\:preLoad').text() == 'true');
                break;
            case 'ns2:BrowserItem':
                interactiveCatalogPageItem = new BrowserItem();
                interactiveCatalogPageItem.url = node.children('ns2\\:url').text();
                interactiveCatalogPageItem.preLoad = (node.children('ns2\\:preLoad').text() == 'true');
                break;
            case 'ns2:MultiStateObjectItem':
                interactiveCatalogPageItem = new MultiStateObjectItem();
                node.children('ns2\\:stateObject').each((i, elem) => {
                    let node = $(elem);
                    let stateObject = new MultiStateObject();
                    stateObject.active = (node.children('ns2\\:active').text() == 'true');
                    stateObject.stateName = node.children('ns2\\:stateName').text();
                    stateObject.item = InteractiveCatalogPageItemParser.parse(node.children('ns2\\:item'));
                    interactiveCatalogPageItem.stateObjects.push(stateObject);
                });
                break;
            case 'ns2:PanoramaImageItem':
                interactiveCatalogPageItem = new PanoramaImageItem();
                interactiveCatalogPageItem.path = node.children('ns2\\:path').text();
                interactiveCatalogPageItem.contentWidth = InteractiveCatalogPageItemParser.parseLayoutNumericValue(node.children('ns2\\:contentWidth'));
                interactiveCatalogPageItem.contentHeight = InteractiveCatalogPageItemParser.parseLayoutNumericValue(node.children('ns2\\:contentHeight'));
                break;
            case 'ns2:TouchAlphaImageItem':
                interactiveCatalogPageItem = new TouchAlphaImageItem();
                interactiveCatalogPageItem.path = node.children('ns2\\:path').text();
                break;
            case 'ns2:TouchImageSequenceItem':
                interactiveCatalogPageItem = new TouchImageSequenceItem();
                node.children('ns2\\:path').each((i, elem) => {
                    interactiveCatalogPageItem.paths.push($(elem).text());
                });
                interactiveCatalogPageItem.loop = (node.children('ns2\\:loop').text() == 'true');
                interactiveCatalogPageItem.direction = node.children('ns2\\:direction').text();
                break;
        }

        interactiveCatalogPageItem.itemId = parseInt(node.children('ns2\\:itemId').text());
        interactiveCatalogPageItem.itemName = node.children('ns2\\:itemName').text();

        interactiveCatalogPageItem.left = InteractiveCatalogPageItemParser.parseLayoutNumericValue(node.children('ns2\\:left'));
        interactiveCatalogPageItem.top = InteractiveCatalogPageItemParser.parseLayoutNumericValue(node.children('ns2\\:top'));
        interactiveCatalogPageItem.width = InteractiveCatalogPageItemParser.parseLayoutNumericValue(node.children('ns2\\:width'));
        interactiveCatalogPageItem.height = InteractiveCatalogPageItemParser.parseLayoutNumericValue(node.children('ns2\\:height'));

        interactiveCatalogPageItem.hidden = (node.children('ns2\\:hidden').text() == 'true');
        interactiveCatalogPageItem.draggable = (node.children('ns2\\:draggable').text() == 'true');
        interactiveCatalogPageItem.clonable = (node.children('ns2\\:clonable').text() == 'true');

        node.children('ns2\\:deviceLanguage').each((i, elem) => {
            // TODO: Parsear nodos
            interactiveCatalogPageItem.deviceLanguages.push($(elem).text());
        });

        node.children('ns2\\:deviceType').each((i, elem) => {
            // TODO: Parsear nodos
            interactiveCatalogPageItem.deviceTypes.push($(elem).text());
        });

        return interactiveCatalogPageItem;
    }

    static parseLayoutNumericValue(node) {
        return parseFloat(parseFloat(node.attr('value')));
    }

}
